import { createFileRoute } from '@tanstack/react-router';
import { OrderView } from '@components/pages/OrderView/OrderView';

export const Route = createFileRoute('/_order/orders/$orderGuid')({
  component: OrderView,
});
